import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const usePetChipStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            gap: 8,
            cursor: 'pointer',
            borderRadius: 100,
            alignItems: 'center',
            fontFamily: 'Poppins',
            display: 'inline-flex',
            border: 'solid 2px transparent',
            padding: '2.5px 18px 2.5px 5px'
        },
        active: {
            borderColor: '#000000'
        },
        petName: {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 500,
            color: '#000000'
        },
        icon: {
            width: 32,
            height: 32,
            fontSize: 16,
            flexShrink: 0,
            color: '#FFFFFF',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },

        iconDog: {
            backgroundColor: '#92B4A7'
        },
        bgDog: {
            backgroundColor: '#E9F0ED'
        },

        iconCat: {
            backgroundColor: '#DBA960'
        },
        bgCat: {
            backgroundColor: '#FAEFDF'
        },

        iconExotic: {
            backgroundColor: '#9C8267'
        },
        bgExotic: {
            backgroundColor: '#EBE7E3'
        }
    })
);
